import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ToggleSwitch = () => {
  const [isOn, setIsOn] = useState(false);

  return (
    <div className="toggle-container" onClick={() => setIsOn(!isOn)}>
      <div className={`toggle-background ${isOn ? "on" : ""}`}>
        <div className={`toggle-circle ${isOn ? "on" : ""}`} />
      </div>
      <label style={{color:'#70707A',fontSize:'17px',marginBottom:'0px'}}>Show Inactive</label>
    </div>
  );
};

export default ToggleSwitch;
